import React, { useMemo } from "react";
import styles from "./reports.module.scss";
import Input from "components/Input";
import Table from "components/Table";
import { authorizationDocsColumns } from "./columns";
import { useQuery } from "@tanstack/react-query";
import { getCompanyAuthDocs, downloadCompanyAuthDoc } from "services/reports";

const mapDoc = (doc) => ({
    id: doc.id,
    jurisdiction: doc.jurisdiction || "—",
    label: doc.label || doc.documentType || doc.name || "—",
    year: doc.year || (doc.filedOn ? new Date(doc.filedOn).getFullYear() : "—"),
    field_on: doc.filedOn
        ? new Date(doc.filedOn).toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "short", day: "numeric" })
        : doc.createdAt
        ? new Date(doc.createdAt).toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "short", day: "numeric" })
        : "—",
});

const AuthorizationDocs = () => {
    const [search, setSearch] = React.useState("");

    const { data: rawDocs, isLoading, isError } = useQuery({
        queryKey: ["companyAuthDocs"],
        queryFn: getCompanyAuthDocs,
    });

    const columns = useMemo(() => authorizationDocsColumns(downloadCompanyAuthDoc), []);

    const docs = Array.isArray(rawDocs) ? rawDocs : (rawDocs?.data ?? rawDocs?.items ?? []);

    const tableData = useMemo(() => {
        return docs
            .map(mapDoc)
            .filter(
                (d) =>
                    !search ||
                    d.label.toLowerCase().includes(search.toLowerCase()) ||
                    d.jurisdiction.toLowerCase().includes(search.toLowerCase())
            );
    }, [docs, search]);

    return (
        <div className={styles.authorizationDocsContainer}>
            <div className={styles.header}>
                <Input
                    placeholder="Search by Label or Jurisdiction"
                    style={{ minWidth: "300px" }}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            {isLoading ? (
                <p className="text-center mt-4 text-muted">Loading documents...</p>
            ) : isError ? (
                <p className="text-center mt-4 text-danger">Failed to load authorization documents.</p>
            ) : tableData.length === 0 ? (
                <p className="text-center mt-4 text-muted">{search ? 'No documents match your search.' : 'No authorization documents found.'}</p>
            ) : (
                <Table
                    headers={columns}
                    data={tableData}
                    containerStyle={{ border: "none", borderRadius: "0px" }}
                />
            )}
        </div>
    );
};

export default AuthorizationDocs;
